<template>
	<div class="container-fluid" id="mainDiv" :class="backgroundTransitionHome">	
	<!-- <h1 style="background-color: black; color: white;">{{isChrome}}</h1> -->
<!-- WELCOME BUTTONS -->
		<transition
						appear
						enter-active-class="animated pulse"
						leave-active-class="animated fadeOut"  
						mode="out-in">
			<div class="col-xs-12 text-center" id="optionsBucket" key="navBar" v-show="showWelcomePage">	
				 	<span v-if="this.$store.state.allowSpeechControl">
				 		<button 	
				 				v-if="initSpeech"
								:class="speechStartStop"
								id="welcomeBtnVoice"
								@click="speechFunc">
								<span id="clickedAbout" v-show="!aboutHideTxtGen"> Click To Use Voice Commands </span>
								<span v-show="aboutHideTxtGen">  </span>
						</button>
					
						<button 	
				 				v-if="!initSpeech"
								:class="speechStartStop"
								id="welcomeBtnVoice"
								@click="stopSpeech">
								<span id="clickedAbout" v-show="!aboutHideTxtGen"> <i :class="speechIconClass" /> {{speechBtnTxt}} </span>
								<span v-show="aboutHideTxtGen">  </span>
						</button>
					</span>
						<br>
				 		<button 	
								:class="aboutBtnClass"
								id="welcomeBtnAbout"
								@click="goToAbout">
								<span id="clickedAbout" v-show="!aboutHideTxtGen"> {{aboutTxt}} </span>
								<span v-show="aboutHideTxtGen">  </span>
						</button>

						<br>

				 		<button 
								id="welcomeBtn"
								:class="btnPlains"
								@click="goToPlains">
								<span id="clickedPlains">{{plainsTxt}}</span>
						</button>

				 		<button 	
								id="welcomeBtn"
								:class="btnOcean"
								@click="goToOcean">
								<span id="clickedOcean">{{oceanTxt}}</span>
						</button>

						<br>

				 		<button 	
								id="welcomeBtn"
								:class="btnAmazon"
								@click="goToAmazon">
								<span id="clickedAmazon">{{amazonTxt}}</span>
						</button>

				 		<button 	
								id="welcomeBtn"
								:class="btnForest"
								@click="goToForest">
								<span id="clickedForest">{{forestTxt}}</span>
						</button>

						<br>

				 		<button 	
								id="welcomeBtn"
								:class="btnDesert"
								@click="goToDesert">
								<span id="clickedDesert">{{desertTxt}}</span>
						</button>

						<button 	
								id="welcomeBtn"
								:class="btnBeach"
								@click="goToBeach">
								<span id="clickedBeach">{{beachTxt}}</span>
						</button>

						<br>

				 		<button 
								id="welcomeBtn"
								:class="btnMetro"
								@click="goToNYC">
								<span id="clickedNYC">{{nycTxt}}</span>
						</button>

				 		<button 	
								id="welcomeBtn"
								:class="btnRural"
								@click="goToRural">
								<span id="clickedRural">{{ruralTxt}}</span>
						</button>

						<br>

						<button 	
								id="welcomeBtn"
								:class="btnFire"
								@click="goTofire">
								<span id="clickedFire">{{fireTxt}}</span>
						</button>

						<button 	
								id="welcomeBtn"
								:class="btnIce"
								@click="goToice">
								<span id="clickedIce">{{iceTxt}}</span>
						</button>
						
						<br>

						<button 	
								:class="btnTut"
								id="welcomeBtnAbout"
								@click="goToTut">
								<span id="clickedTut">{{tutTxt}}</span>
						</button>
														
			</div>
		</transition>		
<!-- ABOUT -->
		<transition
						enter-active-class="animated fadeIn"
						leave-active-class="animated fadeOut"  
						mode="out-in">
			<div class="col-xs-12 text-center" id="aboutPageID" v-show="showAboutPage">	
				 	<p id="aboutTxt" style="text-align: center;">  
						<strong>
							<i class="far fa-headphones"></i> 
							Headphones Recommended 
							<i class="far fa-headphones"></i>
						</strong>
							<!-- <br>
							<i v-if="!isChrome">Control this web app using your voice in Google Chrome</i>
							<i v-if="isChrome">Especially when using the voice user interface.  </i> -->
						<br>
						<br>
						<!-- Every individual sound source contributes its distinct voice to a greater soundscape. These organic sounds are presented to you in their original form. Experiment by processing these organic sounds with digital audio processing. Reconfiguring their soundwaves allows for generative soundscapes. -->  

						Enter this immersive audio experience and explore unique soundscapes from around the world. <span id="lineBreak">Within each soundscape, control individual sounds to create the sonic shape of a greater soundscape.</span> <span id="lineBreak">Use digital audio effects to shape your soundscapes further by twisting and transforming their sound waves.</span>
						<br>
						<br>
						<span v-show="!userMobile"> 
							Ears never blink, we're always listening.
							<br>
						</span>
					</p>
						<button 
							id="aboutSectionVO"
							:class="aboutVOClass"
							@click="aboutVOFunc"
							> <i :class="aboutVOIcon"></i>
							About This Project
						</button>

					<p id="aboutTxt" style="text-align: center;"> 	
						<strong>
						Created & Built by  
							<a href="https://www.mattmccorkle.com" target="_blank" 
								v-bind:style="{'color': aboutVOBoolean ? 'green' : 'red' }">
								Matt McCorkle
							</a>
						</strong>
						<br>
						<span id="shoutOut">
						Utilizing the 
							<strong>
								<a href="https://tonejs.github.io/" target="_blank"
									v-bind:style="{'color': aboutVOBoolean ? 'green' : 'red' }">
									Tone.js
								</a>
							</strong>
							Web Audio Framework
						</span>

						<!-- <span id="shoutOut">Extra special thanks to <a href="https://tonejs.github.io/" target="_blank" style="color: #07CBFF">Tone.js</a> & Yotam Mann</span> -->
						</p>


						<p id="mailingListText" style="color: black;"> 
						Stay in touch for new soundscape releases! 
						<br>
						</p>
						<div id="mc_embed_signup" style="color: black;">
							<form action="https://space.us12.list-manage.com/subscribe/post?u=cc407290614bbaa2daa32fe9e&amp;id=219d3ce36c" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
						<div id="mc_embed_signup_scroll">
							<input type="email" 
								   style="border-color: black; color: black;"
								   value="" 
								   name="EMAIL" 
								   class="email" 
								   id="mce-EMAIL" 
								   placeholder="email address" required>
							<div style="position: absolute; left: -5000px; color: black;" aria-hidden="true"><input type="text" name="b_cc407290614bbaa2daa32fe9e_219d3ce36c" tabindex="-1" value=""></div>
							<input 	type="submit" 
								style="border-color: black; color: black;"
							    value="Subscribe!" 
							    name="subscribe" 
							    id="mc-embedded-subscribe">
						    </div>
							</form>
						</div>
		  				 
						<p id="disclaimerTxt" style="color:black;">
						Sound Design & Recordings Copyright © 2018 Matt McCorkle
						<br>
						<strong> These sounds are presented here for personal entertainment use only. </strong>
						<br>
						For commercial sound licensing email hi@mattmccorkle.com
						<br>
						
						</p>
						<button
							id="aboutBtnID2"
							:class="helpClass"
							@click="goHome">
							<i class="fa fa-window-close fa-3x" aria="true"/>
						</button>
			</div>
		</transition>	
	</div>
</template>

<!-- <script src="https://unpkg.com/unmute" data-add-button="true"></script> -->

<script>
import StartAudioContext from '../../node_modules/startaudiocontext/StartAudioContext.js';
import Tone from '../../node_modules/Tone/build/Tone.min.js';
// import { eventBus } from '../main';

	export default {

		data: () => ({
			// isVoiceControl: false,
		//BOOLEANS
			greatPlainsBoolean: false,
			oceanBoolean:       false,
			amazonBoolean:      false,
			forestBoolean:      false,
			desertBoolean:      false,
			beachBoolean:       false,
			nycBoolean:       	false,
			ruralBoolean:       false,
			iceBoolean:         false,
			fireBoolean:        false,
			aboutBoolean:       false,
			tutBoolean:       	false,

			greatPlainsBooleanTrigger: false,
			oceanBooleanTrigger:       false,
			amazonBooleanTrigger:      false,
			forestBooleanTrigger:      false,
			desertBooleanTrigger:      false,
			beachBooleanTrigger:       false,
			nycBooleanTrigger:       	false,
			ruralBooleanTrigger:       false,
			iceBooleanTrigger:         false,
			fireBooleanTrigger:        false,
			aboutBooleanTrigger:       false,
			tutBooleanTrigger:       	false,

			dontRepeat:         false,
			showWelcomePage:    true,
			showAboutPage:      false,
			oneTimeAbout:       true,
			aboutVOBoolean:     false,


			// showPlains:         true,
			// showOcean: 			true,
			// showAmazon:			true,
			// showForest:			true,
			// showDesert:         true,
			// showBeach:          true,
			// showNYC: 			true,
			// showRural:			true,
			// showIce: 			true,
			// showFire:			true,
			// showAbout:          true,
			// showTut:          	true,
		//TEXTS
			plainsTxt:      	"Grasslands",
			oceanTxt:       	"Pacific Ocean",
			amazonTxt:          "Amazon Rainforest",
			forestTxt:          "Woodland Forest",
			desertTxt:          "Mojave Desert",
			beachTxt:           "Seaside",
			nycTxt:             "New York City",
			ruralTxt:           "Small Town",
			iceTxt:      		"Subzero Sounds",
			fireTxt:            "Sizzling Sounds",
			aboutTxt:     		"Soundscape.cloud",
			tutTxt:     		"Tutorial Soundscape",
			aboutHideTxtGen:    false,
			titleGenTimeout1: undefined,
			titleGenTimeout2: undefined,
			titleGenTimeout3: undefined,
			titleGenTimeout4: undefined,
		//PLAYERS
			welcomeBlink:       new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -14,
			  							}).toMaster(),
			aboutBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -8,
			  							}).toMaster(),
			plainsBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			oceanBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			oceanBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			amazonBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			forestBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			desertBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			beachBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			metroBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			ruralBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			iceBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			fireBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			tutBlink:         new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume": -15,
			  							}).toMaster(),
			aboutVOPlayer: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume" : -6,
			  							}).toMaster(),
			letsTalkVOPlayer: 		new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"volume" : -16,
			  							}).toMaster(),
			// whereToPlayer: 			new Tone.Player({
			//   							"playbackRate" : 1,
			//   							"loop" : false,
			//   							"volume" : -14,
			//   							}).toMaster(),
			aboutVOTimer:           undefined,
		//SPEECH
			//IF SPEECH IS ALLOWED SHOW SPEECH ACTIVATE BUTTON (SET VIA APP.js)
			allowSpeechControl:     false,
			//GLOBAL COMMAND TRIGGERING VOICE COMMANDS ON AND OFF
			isVoiceControl: 		false,
			//COMMAND FOR CSS CONTROL WHEN VOICE IS ACTIVE OR NOT
			recognizing: 			undefined,
			welcomeRecognition:   	undefined,
			//HOLDS ALL OF SPEECHRECONGNITION JSON
			voiceCommandArray:      undefined,
			speechRecognitionList:  undefined,
			voiceCommandConfidence: undefined,
			//STRING LINE TO TEST FOR VOICE COMMAND ACTIONS
			testObjectVUI:             "",
			//BUTTON SWITCHING & TEXT
			initSpeech:             true,
			speechBtnTxt:           "Please Allow Microphone Access To Use This Feature",
			speechCSSTrigger:       false,
			//DISABLE WHILE RECORDING
			isDisableListening:     true,
			//TRUE WHEN STOPPING ALL SPEECH FUNCTIONS TO GO HOME
			stopModuleSpeech:       false,
		//WHAT DEVICE
			isChrome: 				Boolean,
			isFirefox: 				Boolean,
			isSafari: 				Boolean,
			isOpera: 				Boolean,
			isIE: 					Boolean,
			isEdge: 				Boolean,
			isBlink: 				Boolean,
			iOS: 					Boolean,
			AndroidMobile: 			Boolean,
			userMobile: 			Boolean,
		//INITAL SPEECH VO
			onlyPlayVOSpeechOnce:  true,
			voiceActivateVOInterval: undefined,
		//START AUDIO CONTEXT
			startAudioBoolean: 		true,
		}),
		beforeCreate(){
			window.onbeforeunload = ()=> {
				  window.scrollTo(0, 0);
			}
		},
		created(){
			
				this.isVoiceControl = this.$store.state.isVoiceControlled;
				this.allowSpeechControl = this.$store.state.allowSpeechControl;
				if (this.$store.state.isVoiceControlled){
					this.speechBtnTxt = "Where Do You Want To Go?";
				}
				let ua = window.navigator.userAgent;
			        this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
			        this.isFirefox = typeof InstallTrigger !== 'undefined';
			        this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
			        this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
			        this.isIE = /*@cc_on!@*/false || !!document.documentMode;
			        this.isEdge = !this.isIE && !!window.StyleMedia;
			        this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS,
			        this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
			        this.AndroidMobile = /Android/i.test(navigator.userAgent);
			        //CHROME ALLOWS SPEECH AND MEDIA RECORDING
					if (this.isChrome === true){
						this.userMobile = false;
					//FIREFOX ONLY ALLOWS MEDIA RECORDING
					} else if (this.isFirefox === true){
						this.userMobile = false;
					//NO SPEECH AND NO MEDIA RECORDING FOR THE FOLLOWING
					} else if (this.AndroidMobile === true 
							|| this.iOS){
						this.userMobile = true;
					} else if (this.isSafari === true 
							|| this.isOpera === true 
							|| this.isBlink === true 
							|| this.isEdge === true 
							|| this.isIE === true){
						this.userMobile = false;
					}
		        document.body.className = 'default';
		        this.bufferInitLoading();
		        this.loadingAudio();
		        this.titleGeneration();  
		},
		computed: {
			aboutVOClass(){
				return{
							"btn btn-playAbout": this.aboutVOBoolean,
							"btn btn-stopAbout": !this.aboutVOBoolean,
				}
			},
			aboutVOIcon(){
				return {
							"fal fa-times-circle": !this.aboutVOBoolean,
							"fal fa-check-circle": this.aboutVOBoolean
				}
			},	
			aboutBtnClass(){
				return{	
							"btn welcomeBtnShadow": !this.aboutBoolean,
							"btn welcomeBtnNoTxt": 	this.aboutBoolean,
						}
			},
			speechStartStop(){
				return{	
							"btn welcomeBtnShadow": !this.speechCSSTrigger,
							"btn welcomeBtnNoTxt": 	this.speechCSSTrigger,
							"btn voiceCommandAddShadow" : this.recognizing
						}	
			},
			speechIconClass(){
				return {
							"fa fa-microphone-alt fa-spin": this.recognizing,
							"fa fa-microphone-alt": !this.recognizing
				}
			},
			btnOcean(){
				return{
							"btn welcomeBtnShadow": !this.oceanBoolean,
							"btn welcomeBtnNoTxt": this.oceanBoolean,
							"backgroundOcean": 		 this.oceanBoolean,
						}
			},
			btnPlains(){
				return{
							"btn welcomeBtnShadow": !this.greatPlainsBoolean,
							"btn welcomeBtnNoTxt": this.greatPlainsBoolean,
							"backgroundGreatPlains": this.greatPlainsBoolean,
						}
			},
			btnAmazon(){
				return{
							"btn welcomeBtnShadow": !this.amazonBoolean,
							"btn welcomeBtnNoTxt": this.amazonBoolean,
							"backgroundAmazon": 	 this.amazonBoolean,
						}
			},
			btnForest(){
				return{
							"btn welcomeBtnShadow": !this.forestBoolean,
							"btn welcomeBtnNoTxt": this.forestBoolean,
							"backgroundForest": 	 this.forestBoolean,
						}
			},
			btnDesert(){
				return{
							"btn welcomeBtnShadow": !this.desertBoolean,
							"btn welcomeBtnNoTxt": this.desertBoolean,
							"backgroundDesert": 	 this.desertBoolean,
						}
			},
			btnBeach(){
				return{
							"btn welcomeBtnShadow": !this.beachBoolean,
							"btn welcomeBtnNoTxt": this.beachBoolean,
							"backgroundBeach": 	 	 this.beachBoolean,
						}
			},
			btnMetro(){
				return{
							"btn welcomeBtnShadow": !this.nycBoolean,
							"btn welcomeBtnNoTxt": this.nycBoolean,
							"backgroundNYC": 		 this.nycBoolean,
						}
			},
			btnRural(){
				return{
							"btn welcomeBtnShadow": !this.ruralBoolean,
							"btn welcomeBtnNoTxt": this.ruralBoolean,
							"backgroundRural": 		 this.ruralBoolean,
						}
			},
			btnFire(){
				return{
							"btn welcomeBtnShadow": !this.fireBoolean,
							"btn welcomeBtnNoTxt": this.fireBoolean,
							"backgroundfire":        this.fireBoolean,
						}
			},
			btnIce(){
				return{
							"btn welcomeBtnShadow": !this.iceBoolean,
							"btn welcomeBtnNoTxt": this.iceBoolean,
							"backgroundice":  		 this.iceBoolean,
						}
			},
			btnTut(){
				return{
							"btn welcomeBtnShadow": !this.tutBoolean,
							"btn welcomeBtnNoTxt": 	this.tutBoolean,
							"backgroundTutorial":   this.tutBoolean,
						}
			},
			helpClass(){
						return{
							"btn btn-homeHelpBtn1": this.helpTrigger,
							"btn btn-homeHelpBtn2": !this.helpTrigger,
						}
			},
			backgroundTransitionHome(){
						return{	
							"backgroundGreatPlains": this.greatPlainsBooleanTrigger,
							"backgroundOcean": 		 this.oceanBooleanTrigger,
							"backgroundAmazon": 	 this.amazonBooleanTrigger,
							"backgroundForest": 	 this.forestBooleanTrigger,
							"backgroundDesert": 	 this.desertBooleanTrigger,
							"backgroundBeach": 	 	 this.beachBooleanTrigger,
							"backgroundNYC": 		 this.nycBooleanTrigger,
							"backgroundRural": 		 this.ruralBooleanTrigger,
							"backgroundice":  		 this.iceBooleanTrigger,
							"backgroundfire":        this.fireBooleanTrigger,
							"backgroundTutorial":    this.tutBooleanTrigger,
						}
			},
		},
		methods: {	
		//START AUDIO	
			startAudio(){
				StartAudioContext(Tone.context, "#welcomeBtnAbout");
				this.$store.state.hasAudioContextTriggered = true;
				// UnmuteButton({
				// 	//the parent element of the mute button
				// 	//can pass in "none" to create the element, but not add it to the DOM
				// 	container : document.querySelector('#welcomeBtnAbout'),
				// 	//the title which appears on the iOS lock screen
				// 	title : 'Web Audio',
				// 	//force it to start muted, even when the AudioContext is running
				// 	mute : false,
				// 	//AudioContext
				// 	// context : new Aidio,
				// });

			},
		//SPEECH
			welcomeModuleSpeechStart(){
						// this.speechBtnTxt = "Where Do You Want To Go?";
						// this.letsTalkVOPlayer.start();
						// this.onlyPlayVOSpeechOnce = false;
								
						// this.voiceActivateVOInterval = setInterval(()=>{
									
						// 	if (this.letsTalkVOPlayer.state === "stopped"){
								
						// 		// this.welcomeRecognition.start();
						// 		clearInterval(this.voiceActivateVOInterval);
						// 	}
						// }, 60);
			},
			speechFunc(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}	
				if (this.initSpeech === true ){
						this.welcomeRecognition = new webkitSpeechRecognition();
						// console.log(this.welcomeRecognition);
						this.recognizing;
						this.welcomeRecognition.continuous = false;
						this.welcomeRecognition.interimResults = true;
						
						this.welcomeRecognition.onstart = ()=> {
							if (this.onlyPlayVOSpeechOnce){
								if (!this.$store.state.doNotAddress){
									console.log('%c Welcome Module SPEECH Start Up', 'background: black; color: gold');
									this.speechBtnTxt = "Where Do You Want To Go?";
									this.letsTalkVOPlayer.start();
									this.onlyPlayVOSpeechOnce = false;
								}
							}
						}
						this.welcomeRecognition.onresult =  (event)=> {
						  for (let i = event.resultIndex; i < event.results.length; ++i) {
						    if (event.results[i].isFinal) {
						    	if (!this.isDisableListening){	
						    		this.testObject += (event.results[i][0].transcript);
						    		// .toUpperCase();
						     		this.voiceCommandArray = event;
						     		// console.log('I Am Running Inside On Result');
						  		} 
						    }
						  }
						}
						this.welcomeRecognition.onspeechend = ()=> {
								console.log('%c Welcome Module SPEECH Ended', 'background: red; color: black');
								setTimeout(this.voiceCommandAction, 500);
								this.recognizing = false;
								this.speechCSSTrigger = false;
								// if (!this.initSpeech){
									this.speechBtnTxt = "Where Do You Want To Go?";
								// } else if (this.initSpeech){
									// this.speechBtnTxt = "Please Allow Microphone Access To Use This Feature";
								// }
						} 
						this.welcomeRecognition.onspeechstart = ()=> {
								console.log('%c Welcome Module SPEECH Began', 'background: green; color: white');
								this.recognizing = true;
								this.speechCSSTrigger = true;
								this.speechBtnTxt = "Listening For Command";
						}
						this.welcomeRecognition.onsoundstart = ()=> {
							console.log('%c Welcome Module LISTENING Began', 'background: green; color: white');
						} 
						this.welcomeRecognition.onaudioend = ()=> {
							console.log('%c Welcome Module LISTENING Ended', 'background: green; color: white');
							setTimeout(this.voiceCommandAction, 500);
						} 
						this.welcomeRecognition.onend = ()=> {
							console.log('%c Welcome Module SPEECH SESSION ENDED', 'background: green; color: white');
								if (this.stopModuleSpeech === false){
									this.welcomeRecognition.start();
								}
						} 
				//STARTS OUTPUT FLOW OF THE SPEECH RECOGNITION
				this.isDisableListening = false;
				this.$store.state.isVoiceControlled = true;
				this.$store.state.allowSpeechControl = true;
				//STOPS RESTARTING OF THE SPEECH RECOGNITION
				this.stopModuleSpeech = false;		
				this.initSpeech = false;
				this.welcomeRecognition.start();
				
				//KILLS ALL SPEECH FUNCTIONS IF USER DENIES ACCESS OR THERE IS AN ERROR
				this.welcomeRecognition.onerror = function(event) {
						    console.error(event);
						    // this.stopModuleSpeech = true;
						    // this.$store.state.isVoiceControlled = false;
						    // this.$store.state.allowSpeechControl = false;
				};
				} else if (this.initSpeech === false){
					
				}
			},
			resetFunc(){
				this.recognizing = false;
			},
			stopSpeech(){
						//STOP FROM RE_ENTERING SPEECH RECOGNITION LOOP 
						this.stopModuleSpeech = true;
						//DISABLES LISTENING IMMEDITATLY
						this.isDisableListening = true;
						this.$store.state.isVoiceControlled = false;
						//TURNS TRUE SO IF SPEECH IS RE-ENABLED IT WILL RESET PROPERLY
						this.initSpeech = true;
						//CSS SWITCH
						this.recognizing = false;
						//STOP ABORT AND UNDEFINE THE RECOGNITION SERVICE
						this.welcomeRecognition.stop();
						this.welcomeRecognition.abort();
						this.welcomeRecognition = undefined;
			},
			voiceCommandAction(){
				if (!this.isDisableListening){
					let voiceCommandAction = this.testObject;
					console.log('Speech String Command: ' + this.testObject);

						if (RegExp(/grasslands?|plains|prairie/gi).test(this.testObject)){
							this.goToPlains();

						} else if (RegExp(/oceans?|pacific/gi).test(this.testObject)){
							this.goToOcean();

						} else if ((RegExp(/amazons?/gi).test(this.testObject))
								 ||(RegExp(/rainforest/gi).test(this.testObject))){
							this.goToAmazon();

						} else if ((RegExp(/forest/gi).test(this.testObject))
								 ||(RegExp(/woodlands?|wood/gi).test(this.testObject))){
							this.goToForest();
							
						} else if ((RegExp(/des?sert|sands?/gi).test(this.testObject))
								 ||(RegExp(/mojave/gi).test(this.testObject))){
							this.goToDesert();

						} else if ((RegExp(/beachs?|sunn?y?/gi).test(this.testObject))
								 ||(RegExp(/sea[side]/gi).test(this.testObject))){
							this.goToBeach();

						} else if ((RegExp(/nyc/gi).test(this.testObject))
								 ||(RegExp(/new\s?york\s?[city]?/gi).test(this.testObject))){
							this.goToNYC();

						} else if (RegExp(/small\s?town/gi).test(this.testObject)){
							this.goToRural();

						} else if (RegExp(/combustion|flames|fire|heat/gi).test(this.testObject)){
							this.goTofire();

						} else if (RegExp(/sub\s?-?zero/gi).test(this.testObject)){
							this.goToice();

						} else if (RegExp(/tutorial|help/gi).test(this.testObject)){
							this.goToTut();

						} else if (RegExp(/about/gi).test(this.testObject)){
							this.goToAbout();

						} else if (RegExp(/home/gi).test(this.testObject)){
							this.goHome();

						} else if ((RegExp(/stop/gi).test(this.testObject)) 
							&& (RegExp(/voice\s?controls?/gi).test(this.testObject))
							|| (RegExp(/stop/gi).test(this.testObject))
							&& (RegExp(/voice\s?commands?/gi).test(this.testObject))) {
							//STOP FROM RE_ENTERING SPEECH RECOGNITION LOOP 
							this.stopModuleSpeech = true;
							//DISABLES LISTENING IMMEDITATLY
							this.isDisableListening = true;
							this.$store.state.isVoiceControlled = false;
							//TURNS TRUE SO IF SPEECH IS RE-ENABLED IT WILL RESET PROPERLY
							this.initSpeech = true;
							//CSS SWITCH
							this.recognizing = false;
							//STOP ABORT AND UNDEFINE THE RECOGNITION SERVICE
							this.welcomeRecognition.stop();
							this.welcomeRecognition.abort();
							this.welcomeRecognition = undefined;
						} 
						else {
							this.testObject = "";
						}
							this.testObject = "";	
				}
			},
			// isUnderVoiceControl(){
			// 	eventBus.$emit('isVoiceControl', this.isVoiceControl)
			// },
		//TITLE GENERATORS
			titleGeneration(){
				this.titleGenTimeout1 = setTimeout(this.genTextSwitcher1, 2000);
				this.titleGenTimeout2 = setTimeout(this.genTextSwitcher2, 6000);
				// this.titleGenTimeout3 = setTimeout(this.genTextSwitcher1, 4500);
				// this.titleGenTimeout4 = setTimeout(this.genTextSwitcher3, 6000);
				// this.genTxtInterval = setInterval(()=>{
				// 	this.genTextSwitcherBack();
				// 	this.genTxtInterval2 = setTimeout(this.genTextSwitcher, 2500);
				// }, 5000);

				// setTimeout(()=>{
				// 	clearInterval(this.genTxtInterval);
				// 	clearInterval(this.genTxtInterval2);
				// 	setTimeout(()=>{this.aboutTxt = "About This Experiment"}, 250);
				// }, 5000)
			},
			genTextSwitcher1(){
				
				let interval = 25;

				setTimeout(()=>{
					this.aboutTxt = "Soundscape.cloud";
				}, interval * 2);
				setTimeout(()=>{
					this.aboutTxt = "Soundscape.clou";
				}, interval * 3);
				setTimeout(()=>{
					this.aboutTxt = "Soundscape.clo";
				}, interval * 4);
				setTimeout(()=>{
					this.aboutTxt = "Soundscape.cl";
				}, interval * 5);
				setTimeout(()=>{
					this.aboutTxt = "Soundscape.c";
				}, interval * 6);
				setTimeout(()=>{
					this.aboutTxt = "Soundscape.";
				}, interval * 7);
				setTimeout(()=>{
					this.aboutTxt = "Soundscape";
				}, interval * 8);
				setTimeout(()=>{
					this.aboutTxt = "Soundscap";
				}, interval * 9);
				setTimeout(()=>{
					this.aboutTxt = "Soundsca";
				}, interval * 10);
				setTimeout(()=>{
					this.aboutTxt = "Soundsc";
				}, interval * 11);
				setTimeout(()=>{
					this.aboutTxt = "Sounds";
				}, interval * 12);
				setTimeout(()=>{
					this.aboutTxt = "Sound";
				}, interval * 13);
				setTimeout(()=>{
					this.aboutTxt = "Soun";
				}, interval * 14);
				setTimeout(()=>{
					this.aboutTxt = "Sou";
				}, interval * 15);
				setTimeout(()=>{
					this.aboutTxt = "So";
				}, interval * 16);
				setTimeout(()=>{
					this.aboutTxt = "S";
				}, interval * 17);
				setTimeout(()=>{
					this.aboutTxt = "C";
				}, interval * 18);
				setTimeout(()=>{
					this.aboutTxt = "Ch";
				}, interval * 19);
				setTimeout(()=>{
					this.aboutTxt = "Cho";
				}, interval * 20);
				setTimeout(()=>{
					this.aboutTxt = "Choo";
				}, interval * 21);
				setTimeout(()=>{
					this.aboutTxt = "Choos";
				}, interval * 22);
				setTimeout(()=>{
					this.aboutTxt = "Choose";
				}, interval * 23);
				setTimeout(()=>{
					this.aboutTxt = "Choose A";
				}, interval * 24);
				setTimeout(()=>{
					this.aboutTxt = "Choose A S";
				}, interval * 25);
				setTimeout(()=>{
					this.aboutTxt = "Choose A So";
				}, interval * 26);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Sou";
				}, interval * 27);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soun";
				}, interval * 28);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Sound";
				}, interval * 29);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Sounds";
				}, interval * 30);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundsc";
				}, interval * 31);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundsca";
				}, interval * 32);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundscap";
				}, interval * 33);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundscape";
				}, interval * 34);
			},
			// genTextSwitcher1(){
			// 	let interval = 25;

			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Sound Voyage";
			// 	}, interval * 2);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Soun Voyage";
			// 	}, interval * 3);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Sou Voyage";
			// 	}, interval * 4);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "So Voyage";
			// 	}, interval * 5);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "S Voyage";
			// 	}, interval * 6);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "C Voyage";
			// 	}, interval * 7);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Ch Voyage";
			// 	}, interval * 8);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Cho Voyage";
			// 	}, interval * 9);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choo Voyage";
			// 	}, interval * 10);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choos Voyage";
			// 	}, interval * 11);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose Voyage";
			// 	}, interval * 12);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Voyage";
			// 	}, interval * 13);
			// },
			genTextSwitcher2(){
				let interval = 15;

				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundscape";
				}, interval * 1);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundscap";
				}, interval * 2);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundsca";
				}, interval * 3);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soundsc";
				}, interval * 4);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Sounds";
				}, interval * 5);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Sound";
				}, interval * 6);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Soun";
				}, interval * 7);
				setTimeout(()=>{
					this.aboutTxt = "Choose A Sou";
				}, interval * 8);
				setTimeout(()=>{
					this.aboutTxt = "Choose A So";
				}, interval * 9);
				setTimeout(()=>{
					this.aboutTxt = "Choose A S";
				}, interval * 10);
				setTimeout(()=>{
					this.aboutTxt = "Choose A";
				}, interval * 11);
				setTimeout(()=>{
					this.aboutTxt = "Choose";
				}, interval * 12);
				setTimeout(()=>{
					this.aboutTxt = "Choos";
				}, interval * 13);
				setTimeout(()=>{
					this.aboutTxt = "Choo";
				}, interval * 14);
				setTimeout(()=>{
					this.aboutTxt = "Cho";
				}, interval * 15);
				setTimeout(()=>{
					this.aboutTxt = "Ch";
				}, interval * 16);
				setTimeout(()=>{
					this.aboutTxt = "C";
				}, interval * 17);
				setTimeout(()=>{
					this.aboutTxt = "A";
				}, interval * 18);
				setTimeout(()=>{
					this.aboutTxt = "Ab";
				}, interval * 19);
				setTimeout(()=>{
					this.aboutTxt = "Abo";
				}, interval * 20);
				setTimeout(()=>{
					this.aboutTxt = "Abou";
				}, interval * 21);
				setTimeout(()=>{
					this.aboutTxt = "About";
				}, interval * 22);
				setTimeout(()=>{
					this.aboutTxt = "About T";
				}, interval * 23);
				setTimeout(()=>{
					this.aboutTxt = "About Th";
				}, interval * 24);
				setTimeout(()=>{
					this.aboutTxt = "About Thi";
				}, interval * 25);
				setTimeout(()=>{
					this.aboutTxt = "About This";
				}, interval * 26);
				setTimeout(()=>{
					this.aboutTxt = "About This E";
				}, interval * 27);
				setTimeout(()=>{
					this.aboutTxt = "About This Ex";
				}, interval * 28);
				setTimeout(()=>{
					this.aboutTxt = "About This Exp";
				}, interval * 29);
				setTimeout(()=>{
					this.aboutTxt = "About This Expe";
				}, interval * 30);
				setTimeout(()=>{
					this.aboutTxt = "About This Exper";
				}, interval * 31);
				setTimeout(()=>{
					this.aboutTxt = "About This Experi";
				}, interval * 32);
				setTimeout(()=>{
					this.aboutTxt = "About This Experim";
				}, interval * 33);
				setTimeout(()=>{
					this.aboutTxt = "About This Experime";
				}, interval * 34);
				setTimeout(()=>{
					this.aboutTxt = "About This Experimen";
				}, interval * 35);
				setTimeout(()=>{
					this.aboutTxt = "About This Experiment";
				}, interval * 36);
			},
			// genTextSwitcher3(){
				
			// 	let interval = 25;

			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Soundscape";
			// 	}, interval * 1);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Soundscap";
			// 	}, interval * 2);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Soundsca";
			// 	}, interval * 3);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Soundsc";
			// 	}, interval * 4);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Sounds";
			// 	}, interval * 5);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Sound";
			// 	}, interval * 6);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Soun";
			// 	}, interval * 7);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A Sou";
			// 	}, interval * 8);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A So";
			// 	}, interval * 9);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A S";
			// 	}, interval * 10);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose A";
			// 	}, interval * 11);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choose";
			// 	}, interval * 12);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choos";
			// 	}, interval * 13);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Choo";
			// 	}, interval * 14);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Cho";
			// 	}, interval * 15);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Ch";
			// 	}, interval * 16);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "C";
			// 	}, interval * 17);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "A";
			// 	}, interval * 18);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Ab";
			// 	}, interval * 19);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Abo";
			// 	}, interval * 20);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "Abou";
			// 	}, interval * 21);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About";
			// 	}, interval * 22);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About T";
			// 	}, interval * 23);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About Th";
			// 	}, interval * 24);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About Thi";
			// 	}, interval * 25);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This";
			// 	}, interval * 26);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This E";
			// 	}, interval * 27);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Ex";
			// 	}, interval * 28);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Exp";
			// 	}, interval * 29);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Expe";
			// 	}, interval * 30);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Exper";
			// 	}, interval * 31);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Experi";
			// 	}, interval * 32);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Experim";
			// 	}, interval * 33);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Experime";
			// 	}, interval * 34);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Experimen";
			// 	}, interval * 35);
			// 	setTimeout(()=>{
			// 		this.aboutTxt = "About This Experiment";
			// 	}, interval * 36);

			// },
		//TUTORIAL
			goToTut(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
				this.tutBoolean = true;
				this.tutBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				// this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				// this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;

				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

					setTimeout(()=>{
						document.body.className = 'tutorial';
						this.$router.push('/tutorial');
					}, 1000);

				setTimeout(()=>{
					this.disconnectWelcomeAudio();
				}, 2000);

				this.tutBlink.start();
			},
		//ABOUT FUNC
			goToAbout(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				window.scrollTo(0, 0);
				if (this.oneTimeAbout === true){
					this.oneTimeAbout = false;

					
					let textTime = 22;
						
					this.aboutBlink.start();

					setTimeout(()=>{
						this.tutTxt = "";
					}, (textTime));

					setTimeout(()=>{
						this.plainsTxt = "";
					}, (textTime * 10));

					setTimeout(()=>{
						this.oceanTxt = "";
					}, (textTime * 9));
					
					setTimeout(()=>{
						this.amazonTxt = "";
					}, (textTime * 8));
					
					setTimeout(()=>{
						this.forestTxt = "";
					}, (textTime * 7));

					setTimeout(()=>{
						this.desertTxt = "";
					}, (textTime * 6));

					setTimeout(()=>{
						this.beachTxt = "";
					}, (textTime * 5));
					
					setTimeout(()=>{
						this.nycTxt = "";
					}, (textTime * 4));
					
					setTimeout(()=>{
						this.ruralTxt = "";
					}, (textTime * 3));
					
					setTimeout(()=>{
						this.fireTxt = "";
					}, (textTime * 2));
					
					setTimeout(()=>{
						this.iceTxt = "";
					}, (textTime * 1));

					setTimeout(()=>{
						this.aboutTxt = "";
						this.aboutHideTxtGen = true;
					}, (textTime * 11));

					setTimeout(()=>{
						this.showWelcomePage = false;
					}, (textTime * 2));

					setTimeout(()=>{
						this.showAboutPage = true;
					}, (textTime * 42));

					clearInterval(this.titleGenTimeout1);
					clearInterval(this.titleGenTimeout2);
					clearInterval(this.titleGenTimeout3);
					clearInterval(this.titleGenTimeout4);

				} else if (this.oneTimeAbout === false){

				}
			},
			goHome(){
				this.aboutHideTxtGen = false;
				window.scrollTo(0, 0);
				
					this.oneTimeAbout = true;
					
					this.plainsTxt 	= "Grasslands";
					this.oceanTxt 	= "Pacific Ocean";
					this.amazonTxt 	= "Amazon Rainforest";
					this.forestTxt 	= "Woodland Forest";
					this.desertTxt 	= "Mojave Desert";
					this.beachTxt	= "Seaside";
					this.nycTxt 	= "New York City";
					this.ruralTxt 	= "Small Town";
					this.iceTxt 	= "Subzero Sounds";
					this.fireTxt 	= "Sizzling Sounds";
					this.aboutTxt 	= "Sound Voyage";
					this.tutTxt 	= "Tutorial Soundscape";
					
					this.showAboutPage = false;
					this.aboutVOPlayer.stop();
					this.aboutVOBoolean = false;
					clearInterval(this.aboutVOTimer);
					setTimeout(()=>{
						this.showWelcomePage = true;
						this.welcomeBlink.start();

					}, 600);

				this.titleGeneration();  
			},
		//ENTER FUNC MODULES
			goToPlains(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.greatPlainsBoolean = true;
				this.greatPlainsBooleanTrigger = true;
				// this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				// this.greatPlainsBoolean =	false;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.$router.push('/grasslands');
					document.body.className = 'plains';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.plainsBlink.start();
			},
			goToOcean(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.oceanBoolean = true;
				this.oceanBooleanTrigger = true;
				this.plainsTxt = "";
				// this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				// this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/ocean');
					document.body.className = 'ocean';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.oceanBlink.start();
			},
			goToAmazon(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.amazonBoolean = true;
				this.amazonBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				// this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				// this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/amazon');
					document.body.className = 'amazon';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.amazonBlink.start();
			},
			goToForest(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.forestBoolean = true;
				this.forestBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				// this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				// this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/woodlands');
					document.body.className = 'forest';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.forestBlink.start();
			},
			goToDesert(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.desertBoolean = true;
				this.desertBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				// this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				// this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/desert');
					document.body.className = 'desert';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.desertBlink.start();
			},
			goToBeach(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.beachBoolean = true;
				this.beachBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				// this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				// this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/seaside');
					document.body.className = 'beach';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.beachBlink.start();
			},
			goToNYC(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.nycBoolean = true;
				this.nycBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				// this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				// this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/nyc');
					document.body.className = 'nyc';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.metroBlink.start();
			},
			goToRural(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.ruralBoolean = true;
				this.ruralBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				// this.ruralTxt = "";
				this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				// this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/smalltown');
					document.body.className = 'rural';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.ruralBlink.start();
			},
			goToice(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.iceBoolean = true;
				this.iceBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				// this.iceTxt = "";
				this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				// this.iceBoolean 		= 	true;
				this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/ice');
					document.body.className = 'ice';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.iceBlink.start();
			},
			goTofire(){
				if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}
				clearInterval(this.genTxtInterval);
				this.aboutHideTxtGen = true;
				this.fireBoolean = true;
				this.fireBooleanTrigger = true;
				this.plainsTxt = "";
				this.oceanTxt = "";
				this.amazonTxt = "";
				this.forestTxt = "";
				this.desertTxt = "";
				this.beachTxt = "";
				this.nycTxt = "";
				this.ruralTxt = "";
				this.iceTxt = "";
				// this.fireTxt = "";
				this.aboutTxt = "";
				this.tutTxt = "";
				

				this.greatPlainsBoolean =	true;
				this.oceanBoolean 		= 	true;
				this.amazonBoolean 		= 	true;
				this.forestBoolean 		= 	true;
				this.desertBoolean 		=   true;
				this.beachBoolean 		=   true;
				this.nycBoolean 		= 	true;
				this.ruralBoolean 		= 	true;
				this.iceBoolean 		= 	true;
				// this.fireBoolean 		= 	true;
				this.aboutBoolean 		=   true;
				this.tutBoolean 		= 	true;
				this.speechCSSTrigger   =   true;
				
				setTimeout(()=>{	
					this.showWelcomePage = false;
				}, 425);

				setTimeout(()=>{
					this.showWelcomePage = false;
					this.$router.push('/fire');
					document.body.className = 'fire';
					this.disconnectWelcomeAudio();
				}, 1000);

				if (this.$store.state.isVoiceControlled === true){
					this.stopModuleSpeech = true;
					this.welcomeRecognition.abort();
					this.welcomeRecognition = undefined;
				}

				this.fireBlink.start();
			},
		//LOADING AUDIO
			// loadWelcomeTone(){

			// },
			loadingAudio(){
				let ua = window.navigator.userAgent;

					if (this.isChrome === true || 
						this.AndroidMobile === true || 
						this.isOpera === true || 
						this.isFirefox === true || 
						this.isBlink === true){
						
						this.aboutBlink.load("../src/assets/sounds/blinks/aboutBlink.ogg");
						this.welcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.ogg");
						this.plainsBlink.load("../src/assets/sounds/blinks/plainsBlink.ogg");		
						this.oceanBlink.load("../src/assets/sounds/blinks/oceanBlink.ogg");			
						this.amazonBlink.load("../src/assets/sounds/blinks/amazonBlink.ogg");		
						this.forestBlink.load("../src/assets/sounds/blinks/forestBlink.ogg");
						this.desertBlink.load("../src/assets/sounds/blinks/desertBlink.ogg");
						this.beachBlink.load("../src/assets/sounds/blinks/beachBlink.ogg");			
						this.metroBlink.load("../src/assets/sounds/blinks/metroBlink.ogg");			
						this.ruralBlink.load("../src/assets/sounds/blinks/ruralBlink.ogg");			
						this.iceBlink.load("../src/assets/sounds/blinks/iceBlink.ogg");			
						this.fireBlink.load("../src/assets/sounds/blinks/fireBlink.ogg");
						this.tutBlink.load("../src/assets/sounds/blinks/tutBlink.ogg");
						this.aboutVOPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/generativeVO.ogg");
						// this.whereToPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/whereToVO.ogg");
						this.letsTalkVOPlayer.load("../src/assets/sounds/modules/tutorial/hiogg/niceLetsTalkVO.ogg");
						
					} else if (
						this.isSafari === true || 
						this.iOS === true || 
						this.isEdge === true || 
						this.isIE === true){
						
						this.aboutBlink.load("../src/assets/sounds/blinks/aboutBlink.m4a");
						this.welcomeBlink.load("../src/assets/sounds/blinks/welcomeBlink.m4a");
						this.plainsBlink.load("../src/assets/sounds/blinks/plainsBlink.m4a");		
						this.oceanBlink.load("../src/assets/sounds/blinks/oceanBlink.m4a");			
						this.amazonBlink.load("../src/assets/sounds/blinks/amazonBlink.m4a");		
						this.forestBlink.load("../src/assets/sounds/blinks/forestBlink.m4a");
						this.desertBlink.load("../src/assets/sounds/blinks/desertBlink.m4a");
						this.beachBlink.load("../src/assets/sounds/blinks/beachBlink.m4a");			
						this.metroBlink.load("../src/assets/sounds/blinks/metroBlink.m4a");			
						this.ruralBlink.load("../src/assets/sounds/blinks/ruralBlink.m4a");			
						this.iceBlink.load("../src/assets/sounds/blinks/iceBlink.m4a");			
						this.fireBlink.load("../src/assets/sounds/blinks/fireBlink.m4a");
						this.tutBlink.load("../src/assets/sounds/blinks/tutBlink.m4a");
						this.aboutVOPlayer.load("../src/assets/sounds/modules/tutorial/320/generativeVO.m4a");
						  						
					}
				},
				disconnectWelcomeAudio(){
						this.aboutBlink.disconnect();						
						this.welcomeBlink.disconnect();
						this.plainsBlink.disconnect();			
						this.oceanBlink.disconnect();		
						this.amazonBlink.disconnect();			
						this.forestBlink.disconnect();
						this.desertBlink.disconnect();
						this.beachBlink.disconnect();			
						this.metroBlink.disconnect();		
						this.ruralBlink.disconnect();		
						this.iceBlink.disconnect();
						this.fireBlink.disconnect();					
						this.aboutVOPlayer.disconnect();
						// this.whereToPlayer.disconnect();
						this.letsTalkVOPlayer.disconnect();
				},
		//BUFFER LOADING
			bufferInitLoading(){
				Tone.Buffer.on('progress', ()=>{
				});
				Tone.Buffer.on('load', ()=>{
					if (this.$store.state.hasAudioContextTriggered){this.playWelcomeTone();};
					if (this.isVoiceControl === true){
							this.speechFunc();
						}
				});
			},
		//PLAY WELCOME
			playWelcomeTone(){
				// this.welcomeBlink.start();
				if (this.userMobile === false){ 
						this.showWelcomePage = true;
					if (this.dontRepeat === false){
						this.welcomeBlink.start();
						// if (!this.$store.state.isFirstLoad){
								// if(!this.$store.state.allowSpeechControl){
								// setTimeout( () => {this.whereToPlayer.start();}, 50);
						// 	}
						// }
						this.dontRepeat = true;
						this.$store.state.isFirstLoad = false;
					} else if (this.dontRepeat === true){

					}
				}
			},
			aboutVOFunc(){
						
						this.aboutVOBoolean = !this.aboutVOBoolean;
						if (this.aboutVOBoolean === true){
							this.aboutVOPlayer.volume.setTargetAtTime(-13, Tone.Context.currentTime, +0.05);	
							this.aboutVOPlayer.start();

							this.aboutVOTimer = setTimeout(()=>{
								this.aboutVOPlayer.stop();
								this.aboutVOBoolean = false;
							}, 27000);

						} else if (this.aboutVOBoolean === false){	
							

							this.aboutVOPlayer.volume.setTargetAtTime(-70, Tone.Context.currentTime, +0.05);	

							setTimeout(()=>{
								this.aboutVOPlayer.stop();
							}, 250);

							clearInterval(this.aboutVOTimer);
						}	
					},
		}
	}
</script>
<style>	
:root{      
--main-moduleTransition-transition: background .55s ease-out;
}
/* BACKGROUND COLOR CHANGES */
			.backgroundColor1,
			.backgroundColor2,
			.backgroundColor3,
			.backgroundColor4,
			.backgroundColor5,
			.backgroundColor6,
			.backgroundColor7,
			.backgroundColor8,
			.backgroundColor9,
			.backgroundColor10{
				background-color: transparent;	
			}

			.sunReactiveColorClass1,
			.sunReactiveColorClass2,
			.sunReactiveColorClass3,
			.sunReactiveColorClass4,
			.sunReactiveColorClass5,
			.sunReactiveColorClass6,
			.sunReactiveColorClass7,
			.sunReactiveColorClass8,
			.sunReactiveColorClass9,
			.sunReactiveColorClass10{
				background-color: transparent;	
			}
			.backgroundGreatPlains{
				color: white !important;
                background-color: #e0a01f;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }
            .backgroundOcean{
            	color: black !important;
                background-color: white;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            } 
            .backgroundAmazon{
            	color:white !important;
                background-color: #4f601f;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }
            .backgroundForest{
            	color: white !important;
                background-color: #8fd471;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            } 
            .backgroundDesert{
            	color: white !important;
                background-color: #9a6d32;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            } 
            .backgroundBeach{
            	color: white !important;
                background-color: #e4c39a;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }  
            .backgroundNYC{
            	color: black !important;
                background-color: #f1f3f3;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }
            .backgroundRural{
            	color: white !important;
                background-color: #669999;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }  
            .backgroundice{
            	color: white !important;
                background-color: #13c4ec;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }
            .backgroundfire{
            	color: white !important;
                background-color: #ff0000;
                -webkit-transition: var(--main-moduleTransition-transition);
			    -moz-transition: var(--main-moduleTransition-transition);
			    -o-transition: var(--main-moduleTransition-transition);
			    transition: var(--main-moduleTransition-transition);
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }  
            .backgroundTutorial{
            	color: white !important;
                background-color: #000000;
                -webkit-transition:  background 1s ease-out;
			    -moz-transition:  background 1s ease-out;
			    -o-transition:  background 1s ease-out;
			    transition:  background 1s ease-out;
                border-color: transparent !important;
                /*text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);*/  
            }  
/* BOOTSTRAP BUTTON COLORS  */
	.welcomeBtnShadow:active:focus,
	.welcomeBtnShadow:active:hover
	{
	-webkit-box-shadow: inset 0 4px 30px rgba(0, 0, 0, .41) !important;
    box-shadow: inset 0 4px 30px rgba(0, 0, 0, .41) !important;	
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);  
	}

	.welcomeBtnNoTxt,
    .welcomeBtnNoTxt:focus, 
    .welcomeBtnNoTxt:active, 
    .welcomeBtnNoTxt:active:focus,
    .welcomeBtnNoTxt:hover,
	.welcomeBtnNoTxt:active:hover
    .open>.dropdown-toggle.welcomeBtnNoTxt {
    color: black;
    background-color: transparent !important;
    border-color: transparent !important; 
    border-width: 0px;
    } 

    .voiceCommandAddShadow,
    .voiceCommandAddShadow:focus, 
    .voiceCommandAddShadow:active, 
    .voiceCommandAddShadow:active:focus,
    .voiceCommandAddShadow:hover,
	.voiceCommandAddShadow:active:hover
    .open>.dropdown-toggle.voiceCommandAddShadow
	{
	color: black;
    background-color: transparent !important;
    border-color: black !important; 
    border-width: 0px;
	-webkit-box-shadow: inset 0 4px 30px rgba(0, 0, 0, .41) !important;
    box-shadow: inset 0 4px 30px rgba(0, 0, 0, .41) !important;	
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.4);  
	}

    .btn-homeHelpBtn1,
    .btn-homeHelpBtn1:focus, 
    .btn-homeHelpBtn1:active, 
    .btn-homeHelpBtn1:active, 
    .btn-homeHelpBtn1:active:focus,
    .open>.dropdown-toggle.btn-homeHelpBtn1 {
    color: white;
    background-color: white;
    border-color: white; 
    /*border-width: 2px;*/
    } 

    .btn-homeHelpBtn1:hover,
	.btn-homeHelpBtn1:active:hover{
	color: white;
	background-color: white;
	border-color: white; 
	/*border-width: 2px;      */
	}

    .btn-homeHelpBtn2,
    .btn-homeHelpBtn2:focus, 
    .btn-homeHelpBtn2:active, 
    .btn-homeHelpBtn2:active, 
    .btn-homeHelpBtn2:active:focus,
    .open>.dropdown-toggle.btn-homeHelpBtn2 {
    color: black;
    background-color: white;
    border-color: white; 
    /*border-width: 2px;*/
    } 

	.btn-homeHelpBtn2:hover,
	.btn-homeHelpBtn2:active:hover{
	color: white;
	background-color: black;
	border-color: transparent; 
	/*border-width: 2px;      */
	}

	.btn-playAbout,
    .btn-playAbout:hover, 
    .btn-playAbout:focus, 
    .btn-playAbout:active, 
    .btn-playAbout:active, 
    .btn-playAbout:active:focus,
    .btn-playAbout:active:hover,
    .open>.dropdown-toggle.btn-playAbout {
    color: white;
    background-color: green;
    border-color: transparent; 
    border-width: 2px;
    }

    .btn-stopAbout,
    .btn-stopAbout:hover, 
    .btn-stopAbout:focus, 
    .btn-stopAbout:active, 
    .btn-stopAbout:active, 
    .btn-stopAbout:active:focus,
    .btn-stopAbout:active:hover, 
    .open>.dropdown-toggle.btn-stopAbout {
    color: black;
    background-color: red;
    border-color: transparent; 
    border-width: 2px;
    }
</style>


// WEBPACK FOOTER //
// welcome.vue?7fe2ab3c